@if(hasParameters) {
<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <selfai-platform-form-field label="{{ 'workflow.cubes.write-data-frame.field-label.data-source' | translate }}">
    <selfai-platform-data-source-selector
      [control]="form.controls.dataSourceId"
      class="h-15rem"
    ></selfai-platform-data-source-selector>
  </selfai-platform-form-field>

  <selfai-platform-form-field label="{{ 'workflow.cubes.write-data-frame.field-label.overwrite' | translate }}">
    <p-checkbox [binary]="true" [formControl]="form.controls.overwrite"></p-checkbox>
  </selfai-platform-form-field>

  <selfai-platform-form-field label="{{ 'workflow.cubes.write-data-frame.field-label.save-mode' | translate }}">
    <p-dropdown
      [autoDisplayFirst]="false"
      [formControl]="form.controls.saveMode"
      appendTo="body"
      [options]="saveModeOptions"
    ></p-dropdown>
  </selfai-platform-form-field>
</form>
} @else {
<p-message text="{{ 'workflow.cubes.write-data-frame.no-parameters' | translate }}" severity="error"></p-message>
}
